export default __webpack_public_path__ + "static/media/solace-logo-color.22484ec5.svg";